import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"overflow-x":"hidden"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import { ref, computed, toRef } from 'vue'
    import { guid } from '@common/Guid'
    import { isNullOrWhitespace } from '@common/Common'
    import { ProjectUser } from '@Projects/Model'
    import type { ProjectUsersFromStringBuilderViewModel } from '@ProjectUsers/Components/ProjectUsersFromStringBuilder'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUsersFromStringBuilder',
  props: {
    viewModel: {}
  },
  emits: ["create-project-users"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const operationInProgress = computed(() => vm.value.operationInProgress)
    const tags = computed(() => vm.value.tags)

    // writable computed (replaces getter + setter)
    const step = computed<number>({
        get: () => vm.value.step,
        set: v => { vm.value.step = v }
    })

    // ---------------- local state ----------------

    const NamesOrEmails = ref<string | null>(null)
    const ProjectUsers = ref<ProjectUserVM[]>([])

    // ---------------- actions ----------------

    function preview()
    {
        if (!NamesOrEmails.value)
            return

        const lines = NamesOrEmails.value.split(/\r\n|\r|\n/g)
        if (!lines?.length)
            return

        ProjectUsers.value = []

        for (const line of lines)
        {
            if (!line)
                continue

            if (line.includes('\t'))
            {
                const parts = line.split('\t')
                const part1 = parts[0]
                const part2 = parts[1]

                const tagsStr = parts.length === 3 ? parts[2] : null
                let parsedTags =
                    isNullOrWhitespace(tagsStr)
                        ? null
                        : tagsStr!
                            .split(';')
                            .map(t => t.trim())
                            .filter(t => !isNullOrWhitespace(t))

                if (parsedTags)
                {
                    parsedTags = parsedTags.filter(t => tags.value.includes(t))
                }

                if (part1.includes('@'))
                {
                    ProjectUsers.value.push(ProjectUserVM.Create(part2, part1, parsedTags))
                }
                else if (part2.includes('@'))
                {
                    ProjectUsers.value.push(ProjectUserVM.Create(part1, part2, parsedTags))
                }
                else
                {
                    ProjectUsers.value.push(ProjectUserVM.Create(line, null, parsedTags))
                }
            }
            else
            {
                ProjectUsers.value.push(
                    ProjectUserVM.Create(
                        line,
                        line.includes('@') ? line : null,
                        null
                    )
                )
            }
        }

        step.value = 2
    }

    function back()
    {
        step.value = 1
    }

    function handleCreateProjectUsers()
    {
        const projectUsers = ProjectUsers.value
            .filter(p => p.Name)
            .map(p => p.GetData())

        vm.value.operationInProgress = true
        ProjectUsers.value = []
        NamesOrEmails.value = null

        emit('create-project-users', projectUsers)
    }

    function close()
    {
        vm.value.close()
    }

    // ---------------- local helper class ----------------

    class ProjectUserVM
    {
        LocalId: string
        Name: string | null
        Email: string | null
        Tags: string[] | null

        private constructor(
            name: string | null,
            email: string | null,
            tags: string[] | null,
            localId: string
        )
        {
            this.Name = name
            this.Email = email
            this.Tags = tags
            this.LocalId = localId
        }

        static Create(
            name: string | null,
            email: string | null,
            tags: string[] | null
        ): ProjectUserVM
        {
            return new ProjectUserVM(name, email, tags, guid())
        }

        GetData(): ProjectUser
        {
            const pu = new (ProjectUser as any)() as ProjectUser
            pu.ProjectUserId = 0
            pu.LocalId = this.LocalId
            pu.Name = this.Name
            pu.Email = this.Email
            pu.Tags = this.Tags
            return pu
        }
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Add", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (step.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[2] || (_cache[2] = _createElementVNode("label", null, " Insert as many respondent names as you like, with each on a new line ", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((NamesOrEmails).value = $event)),
                          class: "form-control",
                          rows: "8",
                          placeholder: "you can copy and paste here"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            NamesOrEmails.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (step.value === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ProjectUsers.value, (p) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          style: {"margin-bottom":"3px"},
                          key: p.LocalId
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                              class: "form-control",
                              placeholder: "Required name"
                            }, null, 8 /* PROPS */, _hoisted_10), [
                              [
                                _vModelText,
                                p.Name,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              "onUpdate:modelValue": ($event: any) => ((p.Email) = $event),
                              class: "form-control",
                              placeholder: "Optional email"
                            }, null, 8 /* PROPS */, _hoisted_12), [
                              [
                                _vModelText,
                                p.Email,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Tags, (t) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "badge badge-secondary",
                                key: t
                              }, _toDisplayString(t), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (step.value === 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: preview,
                      class: "btn btn-primary"
                    }, " Preview "))
                  : _createCommentVNode("v-if", true),
                (step.value === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: back,
                      class: "btn btn-outline-secondary",
                      disabled: operationInProgress.value
                    }, " Back ", 8 /* PROPS */, _hoisted_15))
                  : _createCommentVNode("v-if", true),
                (step.value === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: handleCreateProjectUsers,
                      disabled: operationInProgress.value,
                      type: "button",
                      class: "btn btn-primary"
                    }, [
                      (operationInProgress.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                            _createTextVNode(" Please wait... ", -1 /* CACHED */)
                          ]))]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, "Save"))
                    ], 8 /* PROPS */, _hoisted_16))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})